import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Attendance from "@/pages/Attendance";
import Leave from "@/pages/Leave";
import Employees from "@/pages/Employees";
import EmployeeProfile from "@/pages/EmployeeProfile";
import Payroll from "@/pages/Payroll";
import DWR from "@/pages/DWR";
import Certifications from "@/pages/Certifications";
import Reports from "@/pages/Reports";
import Assets from "@/pages/Assets";
import Performance from "@/pages/Performance";
import Recruitment from "@/pages/Recruitment";
import Documents from "@/pages/Documents";
import Hierarchy from "@/pages/Hierarchy";
import Team from "@/pages/Team";
import KPI from "@/pages/KPI";
import Training from "@/pages/Training";
import Helpdesk from "@/pages/Helpdesk";
import Expenses from "@/pages/Expenses";
import Security from "@/pages/Security";
import Settings from "@/pages/Settings";
import AppLayout from "@/components/AppLayout";
import { ConfirmProvider } from "@/components/ConfirmDialog";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen w-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="leave" element={<Leave />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employees/:id" element={<EmployeeProfile />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="dwr" element={<DWR />} />
            <Route path="certifications" element={<Certifications />} />
            <Route path="reports" element={<Reports />} />
            <Route path="assets" element={<Assets />} />
            <Route path="performance" element={<Performance />} />
            <Route path="recruitment" element={<Recruitment />} />
            <Route path="documents" element={<Documents />} />
            <Route path="hierarchy" element={<Hierarchy />} />
            <Route path="team" element={<Team />} />
            <Route path="kpi" element={<KPI />} />
            <Route path="training" element={<Training />} />
            <Route path="helpdesk" element={<Helpdesk />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="security" element={<Security />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
